module.exports = __webpack_public_path__ + "media/images/flags/4x3/dma-29411c9a49282669f74ca12a7f4be8c6.svg";